import { countryCodeToFlagEmoji, getCountryField } from './country';

/**
 * Prefix each country dropdown option's label with its flag emoji
 */
export const addFlagEmojiToCountryOptions = () => {
  const countryField = getCountryField();

  if (!countryField || !(countryField instanceof HTMLSelectElement)) return;

  const countrySelect = countryField as HTMLSelectElement;

  Array.from(countrySelect.options).forEach((option) => {
    if (!option.value) return;

    option.text = `${countryCodeToFlagEmoji(option.value)} ${option.text}`;
  });
};

/**
 * Auto-sets the country field (if present) based on the visitor's likely country.
 */
export const autoSetCountryField = async (): Promise<void> => {
  const countryField = getCountryField();

  if (!countryField) return;

  const likelyCountry = await getUserLikelyCountry();

  if (likelyCountry) countryField.value = likelyCountry;
};

/**
 * Calls the We Could Even Tools geolocation API to detect the visitor's likely country.
 * Returns the ISO 3166-1 alpha-2 country code (e.g. "FR"), or undefined if it could not be determined.
 */
export const getUserLikelyCountry = async (): Promise<string | undefined> => {
  try {
    const response = await fetch('https://tools.wecouldeven.com/api/geo');

    if (!response.ok) {
      console.error('Failed to fetch visitor country: unexpected response status', response.status);

      return undefined;
    }

    const result = await response.json();

    if (!result.success) {
      console.error('Failed to fetch visitor country:', result.error);

      return undefined;
    }

    return result.data.country;
  } catch (error) {
    console.error('Error fetching visitor country:', error);

    return undefined;
  }
};
